/**
 * Default configuration for a banner item in the carousel
 *
 * @constant {Object}
 * @property {string} imageUrl - Image URL
 * @property {string} name - Banner name
 * @property {string} linkUrl - URL for the banner link
 * @property {string} description - Banner description
 */
export const DEFAULT_BANNER_ITEM = Object.freeze({
    imageUrl: '',
    name: '',
    linkUrl: '',
    linkText: '',
    description: '',
});

export const MIN_BANNER_ITEMS = 4;
